import { render, staticRenderFns } from "./RulesConfig.vue?vue&type=template&id=d6db8d6e&scoped=true"
import script from "./RulesConfig.vue?vue&type=script&lang=js"
export * from "./RulesConfig.vue?vue&type=script&lang=js"
import style0 from "./RulesConfig.vue?vue&type=style&index=0&id=d6db8d6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6db8d6e",
  null
  
)

export default component.exports